<template>
  <b-modal
    :id="`confirm-block-modal-${deviceId}`"
    title="Block Device"
    size="lg"
    @ok="blockDevice"
  >
    <p>Are you sure you want to block this device?</p>
  </b-modal>
</template>

<script>
import { BModal } from 'bootstrap-vue'

export default {
  components: { BModal },
  props: {
    deviceId: {
      type: String,
      required: true,
    },
    driverId: {
      type: String,
      required: true,
    },
  },
  setup(props, ctx) {
    const blockDevice = async () => {
      try {
        const body = {
          id: props.driverId,
          deviceId: props.deviceId,
        }
        await ctx.root.$store.dispatch('driverView/blockDriverDevice', body)
        ctx.emit('done')
      } catch (error) {
        console.log(error.response)
      }
    }
    return {
      blockDevice,
    }
  },
}
</script>
